module.exports = __webpack_public_path__ + "media/common/icon-envelope-036cd44a.svg";